var uaParser = {exports: {}};

export { uaParser as __module };
//# sourceMappingURL=ua-parser.js.map
